<template>
  <div class="profile-tree-filter-control">
    <s-search-input
      class="profile-tree-filter-control__search-input"
      v-model="searchTerm"
      :placeholder="$t('profile-manager.query.search-placeholder')"
      @input="changingSearch()"
    />
    <div
      class="profile-tree-filter-control__collapse-expand-panel"
    >
      <b-button
        variant="outline-secondary"
        @click="expandAll()"
        class="s-btn-no-custom"
      >
      <span class="fas fa-plus-square profile-tree-filter-control__icon"></span>
        {{ $t('profile-manager.query.tree-expand-all') }}
      </b-button>
      <b-button
        variant="outline-secondary"
        @click="collapseAll()"
        class="s-btn-no-custom"
      >
      <span class="far fa-minus-square profile-tree-filter-control__icon"></span>
        {{ $t('profile-manager.query.tree-collapse-all') }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    value: String,
  },
  data: () => ({
    searchTerm: null,
  }),
  methods: {
    changingSearch() {
      this.$emit('input', this.searchTerm);
    },
    expandAll() {
      this.$emit('expand-all');
    },
    collapseAll() {
      this.$emit('collapse-all');
    },
  },
  watch: {
    value: function changedValue() {
      this.searchTerm = this.value;
    },
  },
  created() {
    this.searchTerm = this.value;
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .profile-tree-filter-control
    display: flex
    flex-direction: column
    &__search-input
      height: 100%
      padding-bottom: 10px
    &__collapse-expand-panel
      display: flex
      > *
        font-size: .9em
        flex: 1
        padding: 3px
        &:first-child
          margin-right: 10px
    &__icon
      margin-right: 5px
</style>
